import styles from './Preloader.module.css';

const Preloader = () => (
  <div className={styles.wrapper}>
    <div className={styles.preloader}>Loading...</div>
  </div>
);

export default Preloader;
